import React from 'react'
import NewUserSelectionCard from '@Components/Cards/NewUserSelectionCard'
import { ICONS } from '@Const/common'

interface SongwriterMusicProfessionalSelectProps {
    setStepState(step: string): void
}

const SongwriterMusicProfessionalSelect = (props: SongwriterMusicProfessionalSelectProps) => {
    const { setStepState } = props
    return (
        <div className="user-options">
            <NewUserSelectionCard
                orientation="vertical"
                icon={ICONS.songwriterHub}
                title="I am a Songwriter"
                description={
                    <p>
                        I write music, melody, and/or lyrics for musical works (songs). I may work solo or collaborate
                        with others to create musical works.
                    </p>
                }
                onClick={() => setStepState('songwriter')}
            />
            <NewUserSelectionCard
                orientation="vertical"
                icon={ICONS.musicProfessionalIcon}
                title="I work for a Company"
                description={
                    <p>
                        I manage musical works (songs) by handling publishing rights, work registrations, and royalties.
                        I may handle legal agreements or other business aspects.
                    </p>
                }
                onClick={() => setStepState('member')}
            />
        </div>
    )
}
export default SongwriterMusicProfessionalSelect
